export default "__VITE_ASSET__DclNunvi__"